@use "../../styles/breakpoints";
@use "../../styles/icon-sizes";

@use "icon-global";

:host {
  --system-color: var(--color-neutral-dark);
  --brand-color-path-one: var(--color-primary-base);
  --brand-color-path-two: var(--color-secondary-light);
  display: inline-block;

  .icon {
    display: block;
    @include icon-sizes.icon-dimensions-sm;

    svg {
      display: block;
    }
  }
}

:host([name*="brand"]) {
  .path-one {
    fill: var(--brand-color-path-one);
  }

  .path-two {
    fill: var(--brand-color-path-two);
  }

  .path-one-color-primary-base {
    .path-one {
      fill: var(--color-primary-base);
    }
  }

  .path-one-color-secondary-light {
    .path-one {
      fill: var(--color-secondary-light);
    }
  }

  .path-two-color-primary-base {
    .path-two {
      fill: var(--color-primary-base);
    }
  }

  .path-two-color-secondary-light {
    .path-two {
      fill: var(--color-secondary-light);
    }
  }
}

:host([name*="system"]) {
  fill: var(--system-color);
}

:host([size-selection="xxs"]) {
  .icon {
    @include icon-sizes.icon-dimensions-xxs;
  }
}

:host([size-selection="xs"]) {
  @include icon-sizes.icon-dimensions-xs;

  .icon {
    @include icon-sizes.icon-dimensions-xs;
  }
}

:host([size-selection="sm"]) {
  @include icon-sizes.icon-dimensions-sm;

  .icon {
    @include icon-sizes.icon-dimensions-sm;
  }
}

:host([size-selection="md"]) {
  @include icon-sizes.icon-dimensions-md;

  .icon {
    @include icon-sizes.icon-dimensions-md;
  }
}

:host([size-selection="lg"]) {
  @include icon-sizes.icon-dimensions-lg;

  .icon {
    @include icon-sizes.icon-dimensions-lg;
  }
}

:host([size-selection="xl"]) {
  @include icon-sizes.icon-dimensions-xl;

  .icon {
    @include icon-sizes.icon-dimensions-xl;
  }
}

@include breakpoints.xsmall-up {
  :host([size-xs-selection="xxs"]) {
    @include icon-sizes.icon-dimensions-xxs;

    .icon {
      @include icon-sizes.icon-dimensions-xxs;
    }
  }

  :host([size-xs-selection="xs"]) {
    @include icon-sizes.icon-dimensions-xs;

    .icon {
      @include icon-sizes.icon-dimensions-xs;
    }
  }

  :host([size-xs-selection="sm"]) {
    @include icon-sizes.icon-dimensions-sm;

    .icon {
      @include icon-sizes.icon-dimensions-sm;
    }
  }

  :host([size-xs-selection="md"]) {
    @include icon-sizes.icon-dimensions-md;

    .icon {
      @include icon-sizes.icon-dimensions-md;
    }
  }

  :host([size-xs-selection="lg"]) {
    @include icon-sizes.icon-dimensions-lg;

    .icon {
      @include icon-sizes.icon-dimensions-lg;
    }
  }

  :host([size-xs-selection="xl"]) {
    @include icon-sizes.icon-dimensions-xl;

    .icon {
      @include icon-sizes.icon-dimensions-xl;
    }
  }
}

@include breakpoints.small-up {
  :host([size-sm-selection="xxs"]) {
    @include icon-sizes.icon-dimensions-xxs;

    .icon {
      @include icon-sizes.icon-dimensions-xxs;
    }
  }

  :host([size-sm-selection="xs"]) {
    @include icon-sizes.icon-dimensions-xs;

    .icon {
      @include icon-sizes.icon-dimensions-xs;
    }
  }

  :host([size-sm-selection="sm"]) {
    @include icon-sizes.icon-dimensions-sm;

    .icon {
      @include icon-sizes.icon-dimensions-sm;
    }
  }

  :host([size-sm-selection="md"]) {
    @include icon-sizes.icon-dimensions-md;

    .icon {
      @include icon-sizes.icon-dimensions-md;
    }
  }

  :host([size-sm-selection="lg"]) {
    @include icon-sizes.icon-dimensions-lg;

    .icon {
      @include icon-sizes.icon-dimensions-lg;
    }
  }

  :host([size-sm-selection="xl"]) {
    @include icon-sizes.icon-dimensions-xl;

    .icon {
      @include icon-sizes.icon-dimensions-xl;
    }
  }
}

@include breakpoints.medium-up {
  :host([size-md-selection="xxs"]) {
    @include icon-sizes.icon-dimensions-xxs;

    .icon {
      @include icon-sizes.icon-dimensions-xxs;
    }
  }

  :host([size-md-selection="xs"]) {
    @include icon-sizes.icon-dimensions-xs;

    .icon {
      @include icon-sizes.icon-dimensions-xs;
    }
  }

  :host([size-md-selection="sm"]) {
    @include icon-sizes.icon-dimensions-sm;

    .icon {
      @include icon-sizes.icon-dimensions-sm;
    }
  }

  :host([size-md-selection="md"]) {
    @include icon-sizes.icon-dimensions-md;

    .icon {
      @include icon-sizes.icon-dimensions-md;
    }
  }

  :host([size-md-selection="lg"]) {
    @include icon-sizes.icon-dimensions-lg;

    .icon {
      @include icon-sizes.icon-dimensions-lg;
    }
  }

  :host([size-md-selection="xl"]) {
    @include icon-sizes.icon-dimensions-xl;

    .icon {
      @include icon-sizes.icon-dimensions-xl;
    }
  }
}

@include breakpoints.large {
  :host([size-lg-selection="xxs"]) {
    @include icon-sizes.icon-dimensions-xxs;

    .icon {
      @include icon-sizes.icon-dimensions-xxs;
    }
  }

  :host([size-lg-selection="xs"]) {
    @include icon-sizes.icon-dimensions-xs;

    .icon {
      @include icon-sizes.icon-dimensions-xs;
    }
  }

  :host([size-lg-selection="sm"]) {
    @include icon-sizes.icon-dimensions-sm;

    .icon {
      @include icon-sizes.icon-dimensions-sm;
    }
  }

  :host([size-lg-selection="md"]) {
    @include icon-sizes.icon-dimensions-md;

    .icon {
      @include icon-sizes.icon-dimensions-md;
    }
  }

  :host([size-lg-selection="lg"]) {
    @include icon-sizes.icon-dimensions-lg;

    .icon {
      @include icon-sizes.icon-dimensions-lg;
    }
  }

  :host([size-lg-selection="xl"]) {
    @include icon-sizes.icon-dimensions-xl;

    .icon {
      @include icon-sizes.icon-dimensions-xl;
    }
  }
}
